/*
 * sidebar-toggle
 */
import { cn } from "@psychology/react-ui"
import { Button } from "@psychology/react-ui"
import { ChevronLeft } from "lucide-react"

type SidebarToggleProps = {
	isOpen: boolean
	setIsOpen: () => void
}

export function SidebarToggle({ isOpen, setIsOpen }: SidebarToggleProps) {
	return (
		<div
			className={
				"border-border invisible absolute -right-4 top-2 z-20 rounded-md bg-transparent lg:visible"
			}
		>
			<Button
				onClick={() => setIsOpen?.()}
				className={"size-8 rounded-md"}
				variant={"outline"}
				size={"icon"}
			>
				<ChevronLeft
					className={cn(
						"h-4 w-4 transition-transform duration-700 ease-in-out",
						isOpen === false ? "rotate-180" : "rotate-0",
					)}
				/>
			</Button>
		</div>
	)
}
